import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './messages';
import ServiceDetailsField from './service-details-field';
import UserDateTimezoneFormat from '../../../../components/user-date-timezone-format';
import { UserDateTimePropType } from '../../../../prop-types/user-date-time';

const DELEGATION_DATE_FIELD_ID = 'rate-card-delegation-date';

export const DelegationDate = ({ delegationDateTime }) => {
  return (
    <ServiceDetailsField
      label={<FormattedMessage {...messages.delegationDateLabel} />}
      labelId={DELEGATION_DATE_FIELD_ID}
      value={delegationDateTime && <UserDateTimezoneFormat dateTime={delegationDateTime} />}
    />
  );
};

DelegationDate.propTypes = {
  delegationDateTime: UserDateTimePropType,
};
